import { z } from "zod";

import {
	BasicCustomMailOptionalItemOverrideInputSchema,
	BasicCustomMailRequiredItemOverrideInputSchema,
	EmailTemplateReservationInputSchema,
	PlanI18nInputSchema,
	QuestionItemInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

import type { ZodError } from "zod";

export const dayTripPlanI18nInputZodSchema = PlanI18nInputSchema.extend({
	name: z.string().min(1).max(150),
	mainTarget: z.string().max(70).nullish(),

	emailTemplateReservation: EmailTemplateReservationInputSchema.extend({
		atCreated: z.string().max(3_000).nullish(),
		atUpdated: z.string().max(3_000).nullish(),
		atCanceled: z.string().max(3_000).nullish(),
		atCin: z.string().max(3_000).nullish(),
	}).nullish(),

	questions: z.array(
		QuestionItemInputSchema.extend({
			question: z.string().min(1).max(8_000),
			options: z.array(z.string().min(1).max(500)).nullish(),
			required: z.boolean().nullish(),
		}),
	),

	atCreated: BasicCustomMailRequiredItemOverrideInputSchema.extend({
		text: z.string().max(3_000),
		override: z.boolean(),
	}),
	atUpdated: BasicCustomMailRequiredItemOverrideInputSchema.extend({
		text: z.string().max(3_000),
		override: z.boolean(),
	}),
	atCanceled: BasicCustomMailRequiredItemOverrideInputSchema.extend({
		text: z.string().max(3_000),
		override: z.boolean(),
	}),
	atCheckInBefore_07days: BasicCustomMailOptionalItemOverrideInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
		override: z.boolean(),
	}),
	atCheckInBefore_01days: BasicCustomMailOptionalItemOverrideInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
		override: z.boolean(),
	}),
	atCheckInBefore_00days: BasicCustomMailOptionalItemOverrideInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
		override: z.boolean(),
	}),
	atCheckOutAfter_01days: BasicCustomMailOptionalItemOverrideInputSchema.extend({
		text: z.string().max(3_000),
		shouldSendEmail: z.boolean(),
		override: z.boolean(),
	}),
});

export type DayTripPlanI18nInputZodSchemaType = z.infer<typeof dayTripPlanI18nInputZodSchema>;

export type DayTripPlanI18nInputZodParseErrorType = ZodError<DayTripPlanI18nInputZodSchemaType>;
